// Redux/Actions/vrShootRequestActions.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewVrShootRequestList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_VR_SHOOT_REQUEST_LIST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/vr-shoot/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_VR_SHOOT_REQUEST_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_VR_SHOOT_REQUEST_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_VR_SHOOT_REQUEST_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewVrShootRequest = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_VR_SHOOT_REQUEST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(
        `${BASE_URL}/vr-shoot/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_VR_SHOOT_REQUEST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_VR_SHOOT_REQUEST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_VR_SHOOT_REQUEST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};